export default __webpack_public_path__ + "static/media/Frame 3216mob.5282f351.png";